import { DEFAULT_CONFIG, type ThemeConfig } from "./hooks/useThemeConfig";

export interface Preset {
  id: string;
  name: string;
  description: string;
  config: ThemeConfig;
}

export const PRESETS: Preset[] = [
  {
    id: "default",
    name: "Default",
    description: "Out-of-the-box look. Indigo accent, soft pill, neutral off state.",
    config: DEFAULT_CONFIG,
  },
  {
    id: "ios",
    name: "iOS",
    description: "Apple-style switch. Filled green ON, neutral grey OFF, tight knob.",
    config: {
      ...DEFAULT_CONFIG,
      width: 76,
      height: 44,
      borderWidth: 0,
      radius: 22,
      radiusBackground: 22,
      knobRadius: 999,
      knobWidth: 38,
      knobHeight: 38,
      knobGap: 3,
      leftBorderColor: "#e5e5ea",
      leftBackgroundColor: "#e5e5ea",
      leftKnobColor: "#ffffff",
      rightBorderColor: "#34c759",
      rightBackgroundColor: "#34c759",
      rightKnobColor: "#ffffff",
    },
  },
  {
    id: "material",
    name: "Material",
    description: "MD3-flavoured. Bigger knob hangs out, branded primary.",
    config: {
      ...DEFAULT_CONFIG,
      width: 60,
      height: 28,
      borderWidth: 2,
      radius: 999,
      radiusBackground: 999,
      knobRadius: 999,
      knobWidth: 28,
      knobHeight: 28,
      knobGap: 0,
      leftBorderColor: "#79747e",
      leftBackgroundColor: "#e6e0e9",
      leftKnobColor: "#79747e",
      rightBorderColor: "#6750a4",
      rightBackgroundColor: "#6750a4",
      rightKnobColor: "#ffffff",
    },
  },
  {
    id: "pill",
    name: "Pill",
    description: "Wide pill, oversized knob, candy colors.",
    config: {
      ...DEFAULT_CONFIG,
      width: 100,
      height: 36,
      borderWidth: 0,
      radius: 999,
      radiusBackground: 999,
      knobRadius: 999,
      knobWidth: 28,
      knobHeight: 28,
      knobGap: 4,
      leftBorderColor: "#e4e4e7",
      leftBackgroundColor: "#e4e4e7",
      leftKnobColor: "#ffffff",
      rightBorderColor: "#a855f7",
      rightBackgroundColor: "#a855f7",
      rightKnobColor: "#ffffff",
    },
  },
  {
    id: "square",
    name: "Square",
    description: "Brutalist boxy switch with sharp corners.",
    config: {
      ...DEFAULT_CONFIG,
      width: 64,
      height: 32,
      borderWidth: 2,
      radius: 4,
      radiusBackground: 2,
      knobRadius: 2,
      knobWidth: 24,
      knobHeight: 24,
      knobGap: 2,
      leftBorderColor: "#0a0a0a",
      leftBackgroundColor: "#fafafa",
      leftKnobColor: "#0a0a0a",
      rightBorderColor: "#0a0a0a",
      rightBackgroundColor: "#0a0a0a",
      rightKnobColor: "#fafafa",
    },
  },
  {
    id: "neon",
    name: "Neon",
    description: "Cyber neon — pink ON state, dark substrate.",
    config: {
      ...DEFAULT_CONFIG,
      width: 76,
      height: 32,
      borderWidth: 2,
      radius: 999,
      radiusBackground: 999,
      knobRadius: 999,
      knobWidth: 22,
      knobHeight: 22,
      knobGap: 4,
      leftBorderColor: "#27272a",
      leftBackgroundColor: "#0a0a0a",
      leftKnobColor: "#52525b",
      rightBorderColor: "#ec4899",
      rightBackgroundColor: "#0a0a0a",
      rightKnobColor: "#ec4899",
    },
  },
  {
    id: "minty",
    name: "Minty",
    description: "Fresh teal-mint, oversized track, tiny knob.",
    config: {
      ...DEFAULT_CONFIG,
      width: 80,
      height: 24,
      borderWidth: 0,
      radius: 999,
      radiusBackground: 999,
      knobRadius: 999,
      knobWidth: 16,
      knobHeight: 16,
      knobGap: 4,
      leftBorderColor: "#d4d4d8",
      leftBackgroundColor: "#d4d4d8",
      leftKnobColor: "#71717a",
      rightBorderColor: "#14b8a6",
      rightBackgroundColor: "#14b8a6",
      rightKnobColor: "#ffffff",
    },
  },
  {
    id: "tactile",
    name: "Tactile",
    description: "Big rounded rectangle knob, two-tone track.",
    config: {
      ...DEFAULT_CONFIG,
      width: 84,
      height: 40,
      borderWidth: 2,
      radius: 12,
      radiusBackground: 10,
      knobRadius: 8,
      knobWidth: 32,
      knobHeight: 32,
      knobGap: 4,
      leftBorderColor: "#e4e4e7",
      leftBackgroundColor: "#fafafa",
      leftKnobColor: "#a1a1aa",
      rightBorderColor: "#0ea5e9",
      rightBackgroundColor: "#e0f2fe",
      rightKnobColor: "#0ea5e9",
    },
  },
];
